import {View} from "../../km_app/types/View";

/** DSA-A-71 `location` values for KM `view_item_list`. */
export const getAmplitudeViewItemListLocationByView = (viewType: View): string | undefined => {
    switch (viewType) {
        case View.APPLICATION_SENT:
            return "hm_sent_offers";
        case View.FAVORITE:
            return "hm_favourite_offers";
        case View.DISMISSED:
            return "hm_rejected_offers";
        case View.COMPARATOR:
            return "hm_favourite_offers_comparison";
        default:
            return undefined;
    }
};
import {View} from "../../km_app/types/View";

/** DSA-A-71 `location` values for KM `view_item_list`. */
export const getAmplitudeViewItemListLocationByView = (viewType: View): string | undefined => {
    switch (viewType) {
        case View.APPLICATION_SENT:
            return "hm_sent_offers";
        case View.FAVORITE:
            return "hm_favourite_offers";
        case View.DISMISSED:
            return "hm_rejected_offers";
        case View.COMPARATOR:
            return "hm_favourite_offers_comparison";
        default:
            return undefined;
    }
};
